import React, { useEffect, useState } from "react";
import { MButton } from "@/components/ui/atoms/MButtons";
import NoteUnreadBadge from "@/components/ui/atoms/NoteUnreadBadge";
import { useNotesContext } from "@/context/NotesContext";
import { trackUserDataLoaded } from "@/utils/gtm";
import {
  ANALYTICS_SCREEN_TYPES,
  ANALYTICS_SCREEN_NAMES,
} from "@/constants/analytics.constants";
import { getMemberInfo } from "@/hooks/useMembers";

const FamilyNotesButtonWithBadge = ({
  loggedInMember,
  navigate,
}: {
  loggedInMember: any;
  navigate: any;
}) => {
  const { unreadCount } = useNotesContext();
  const memberInfo = getMemberInfo(true);

  const handleClick = () => {
    // Track family notes click
    trackUserDataLoaded({
      memberInfo,
      screenType: ANALYTICS_SCREEN_TYPES.FAMILY,
      screenName: ANALYTICS_SCREEN_NAMES.FAMILY_NOTES,
    });

    navigate("/profile/family/notes");
  };

  return (
    <MButton
      data-family-notes-button
      variant="outline"
      size="sm"
      state="default"
      style={{ width: "100%", position: "relative" }}
      onClick={handleClick}
    >
      <span className="body-base-semibold">Family notes</span>
      {unreadCount > 0 && <NoteUnreadBadge count={unreadCount} />}
    </MButton>
  );
};

export default FamilyNotesButtonWithBadge;
